import { Link, useParams } from "@tanstack/react-router";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { DocsMarkdown } from "../DocsMarkdown";
import {
  audienceLabelFor,
  getArticle,
  siblingArticles,
} from "../docsContent";

export function DocsArticlePage() {
  const { slug } = useParams({ from: "/docs/$slug" });
  const article = getArticle(slug);

  if (!article) {
    return (
      <div data-testid="docs-article-missing" className="docs-document docs-document-missing">
        <p className="eyebrow">Help center</p>
        <h2>We couldn’t find that guide.</h2>
        <p className="mt-2 text-ink-muted">
          Choose a topic from the help center.
        </p>
        <Link
          to="/docs"
          className="docs-tonal-link"
        >
          <ArrowLeft className="size-4" /> Back to all help
        </Link>
      </div>
    );
  }

  const { prev, next } = siblingArticles(slug);
  return (
    <div
      data-testid="docs-article"
      className="docs-article"
    >
      <article className="docs-document">
        <p className="eyebrow">Tktic help · {audienceLabelFor(article.audience)}</p>
        <DocsMarkdown body={article.body} />

        {/* Prev / next within the audience */}
        {(prev || next) && (
          <nav
            aria-label="More in this section"
            data-testid="docs-prevnext"
            className="docs-prev-next"
          >
            {prev ? (
              <Link
                to="/docs/$slug"
                params={{ slug: prev.slug }}
                className="docs-tonal-link docs-prev-link"
              >
                <ArrowLeft aria-hidden="true" />
                <span>{prev.title}</span>
              </Link>
            ) : (
              <span />
            )}
            {next ? (
              <Link
                to="/docs/$slug"
                params={{ slug: next.slug }}
                className="docs-tonal-link docs-next-link"
              >
                <span>{next.title}</span>
                <ArrowRight aria-hidden="true" />
              </Link>
            ) : (
              <span />
            )}
          </nav>
        )}
      </article>

    </div>
  );
}
